import React from 'react';
import { i18n_meditation } from '@yi/i18n/phrases/i18n_meditation';

import { MeditationCarousel } from '~/src/components/carousels/MeditationCarousel';
import { LazyRender } from '~/src/components/LazyRender';
import { useLocale } from '~/src/components/LocaleProvider';

import { MeditaionCarouselDataEN } from './MeditaionCarouselDataEN';
import { MeditaionCarouselDataES } from './MeditaionCarouselDataES';
import { carouselSettings, spaceBetweenCards } from '../carouselSettings';

const Data: React.FC<{
  children: (data: React.ComponentProps<typeof MeditationCarousel>['items']) => React.ReactNode;
}> = props => {
  const { locale } = useLocale();
  if (locale === 'es') {
    return <MeditaionCarouselDataES {...props} />;
  }
  return <MeditaionCarouselDataEN {...props} />;
};
const dimension = {
  width: 282,
  height: 263,
};

export const MeditaionCarousel: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();

  return (
    <div {...props}>
      <Data>
        {data => (
          <LazyRender
            placeholder={
              <MeditationCarousel.Placeholder
                dimension={dimension}
                heading={i18n_meditation(locale)}
                button={null}
                headerCSS={carouselSettings.headerCSS}
              />
            }
          >
            <MeditationCarousel
              items={data}
              heading={i18n_meditation(locale)}
              dimension={dimension}
              {...carouselSettings}
              style={{ width: `${dimension.width + spaceBetweenCards}px` }}
            />
          </LazyRender>
        )}
      </Data>
    </div>
  );
};
